// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import {forEach} from "ramda";

const fragments = {
    VARIANT: '[data-fragment="EshopProductTile.variant"]'
};

export default class EshopProductTile extends WebComponent {
    constructor(props) {
        super(props);
        this.variantMouseEnter = this.variantMouseEnter.bind(this);
        this.variantMouseLeave = this.variantMouseLeave.bind(this);
    }

    didMount() {
        const self = this;
        this.form = this.element.querySelector('.product-list__variant-form');
        this.variants = this.element.querySelectorAll(fragments.VARIANT);
        this.motive = this.element.querySelector('.product-list__motive');
        this.motiveOriginalSrc = this.motive.src;
        if (!this.motiveOriginalSrc.includes('variant') && !this.motiveOriginalSrc.includes('placeholder')) {
            this.motiveOriginalSrc = this.motive.dataset['src'];
        }
        this.variants.forEach(function (item) {
            item.addEventListener('mouseenter', self.variantMouseEnter);
            item.addEventListener('mouseleave', self.variantMouseLeave);
        });

        if (this.form) {
            window.addEventListener("pageshow", () => {
                self.form.reset();
            });
        }
    }

    variantMouseEnter(e) {
        this.motive.src = e.target.dataset['imgOver'];
    }

    variantMouseLeave() {
        this.motive.src = this.motiveOriginalSrc;
    }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/EshopProductTile.js